export default function notEq(left, right) {
  return left !== right;
}